import React from 'react';
import { ButtonApp } from 'src/components/ApartmentPageV2/Button';
import { ReactComponent as LockDealIcon } from 'src/assets/icon_apartment_lock.svg';
import { useStyles } from 'src/components/ApartmentConnectDeal/components/Buttons/CantBeUnLinkedButton/styles';

export const BlockedButton: React.FC<{children: React.ReactNode, label: string}> = ({ children, label }) => {
  const styles = useStyles();
  return (
    <div className={styles.wrapper}>
      <ButtonApp
        startIcon={<LockDealIcon />}
        customClassName={styles.button}
        fullWidth
        text={label}
        variant="contained"
        disabled
      />
      {children}
    </div>
  );
};
